module.exports = {"TXTWCL_Something_went_wrong":{"id":"TXTWCL_Something_went_wrong","defaultMessage":"何らかの障害が発生しました","track":"Something went wrong"}}